<template>
  <div class="tool-item">
    <div>
      <a href="javascript:void(0)" @click="inidata">
        <img src="../../assets/contract2.png" width="24" height="24">
      </a>
    </div>
    <el-dialog class="newDialog carte previewFile" title="個人名片" :visible.sync="visible">
      <div v-if="this.businesscard.absoluteUrl=='' || this.businesscard.absoluteUrl==null">尚未設定</div>
      <div v-else>
        <img height="50%" :src="businesscard.absoluteUrl">
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitForm()">送 出</el-button>
          <el-button @click="visible = false">取 消</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>


<script>
import Global from "@/components/Global";
import { SaleBusinessCardHandler } from "@/handler/SaleBusinessCardHandler.js";

export default {
  name: "SaleBusinessCard",
  data() {
    return {
      visible: false,
      businesscard: { absoluteUrl: "", previewImageUrl: "" }
    };
  },
  methods: {
    inidata: function() {
      this.businesscard = SaleBusinessCardHandler.GetSalesBussinessCard();
      this.visible = true;
    },
    submitForm() {
      SaleBusinessCardHandler.SendMediaMessage(this.businesscard);
      this.visible = false;
    }
  }
};
</script> 



<style>
</style>


// WEBPACK FOOTER //
// src/components/SalesTool/SaleBusinessCard.vue